import React from 'react';
import { Grid } from '@material-ui/core';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import ScrollableTabPanel from '../../../common/ScrollableTabPanel';
import { closePopupAction } from '../../../../Actions/surveyAction';
import Loader from '../../../common/customLoader';

const months = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};

class CCEPopup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      closePopupFunc,
      experimentDetailLoading,
      experimentDetailError,
      experimentDetail,
      previewExperimentNumber,
    } = this.props;
    const { surveyDetails, mediaURL, stage2Media } = experimentDetail;
    let tabsData = [];
    if (!_.isEmpty(experimentDetail)) {
      if (!_.isEmpty(surveyDetails)) {
        tabsData = [
          {
            tabName: 'Part 1 Field Overview',
            component: (
              <div className="survey-tab">
                <div className="survey-tab__content">
                  <div className="survey-tab__body">
                    <Grid container className="survey-tab__body__palette">
                      <h1>Geographic Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            State
                            {' '}
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            District
                            <span>
                              {surveyDetails.districtName || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            L4 Name
                            <span>{surveyDetails.level4Name || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Season/Year
                            <span>{surveyDetails.sssyID || 'xxxxxxx'}</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            L5 Name
                            {' '}
                            <span>{surveyDetails.sssyID || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            L6 Name
                            {' '}
                            <span>{surveyDetails.level6Name || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            L7 Name
                            {' '}
                            <span>{surveyDetails.level7Name || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Crop Name
                            {' '}
                            <span>{surveyDetails.cropName || 'xxxxxxx'}</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>
                        Field Details
                        {' '}
                        <span>
                          Co ordinates:
                          {' '}
                          <strong>564543.787645</strong>
                        </span>
                      </h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Total Area(Unit)
                            {' '}
                            <span>{surveyDetails.khataArea || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Dimentions
                            <span>{`${surveyDetails.plotLength}x${surveyDetails.plotBreadth} ${surveyDetails.plotDimension.plotBreadth}`}</span>
                          </li>
                          <li>
                            Survey/Subdivision
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Farmer Present -
                            {' '}
                            <strong>
                              {surveyDetails.icUserPresent ? 'Yes' : 'No'}
                            </strong>
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Farmer Name
                            {' '}
                            <span>
                              {surveyDetails.cultivatorName || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Mobile Number
                            <span>
                              {surveyDetails.cultivatorMobile || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Farmer ID
                            <span>
                              {surveyDetails.cultivatorAadhar || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Harvest Date
                            <span>
                              {`${new Date(
                                surveyDetails.dateOfHarvesting,
                              ).getDate()} ${
                                months[
                                  new Date(
                                    surveyDetails.dateOfHarvesting,
                                  ).getMonth()
                                ]
                              } ${new Date(
                                surveyDetails.dateOfHarvesting,
                              ).getFullYear()}` || 'xxxxxxx'}
                            </span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Sub Section C</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__img">
                      {stage2Media.map((item, index) => {
                        if (index < 5) {
                          return (
                            <figure key={item.stage2ID}>
                              <img
                                src={`${mediaURL}${item.mediaRelativePath}`}
                                alt={`0${index + 1}`}
                              />
                              <p>
                                {item.mediaType
                                  ? item.mediaType.split('_').join(' ')
                                  : `Media ${index + 1}`}
                              </p>
                            </figure>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  </div>
                  <Grid container className="survey-tab__footer">
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Delete</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Download</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">CTA</button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
          {
            tabName: 'Part-2 crop-details',
            component: (
              <div className="survey-tab">
                <div className="survey-tab__content">
                  <div className="survey-tab__body">
                    <Grid container className="survey-tab__body__palette">
                      <h1>Cropping Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Random Number
                            <span>{surveyDetails.randomNo || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Date of Sowing
                            <span>
                              {`${new Date(
                                surveyDetails.dateOfSowing,
                              ).getDate()} ${
                                months[
                                  new Date(
                                    surveyDetails.dateOfSowing,
                                  ).getMonth()
                                ]
                              } ${new Date(
                                surveyDetails.dateOfSowing,
                              ).getFullYear()}` || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Cultivation System
                            <span>
                              {surveyDetails.cultivationSystem || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Mixed Cropping
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Land Type
                            <span>
                              {surveyDetails.cceLandType || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Sowing Time
                            <span>{surveyDetails.sowingTime || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Date of Cutting
                            <span>
                              {`${new Date(
                                surveyDetails.dateOfCutting,
                              ).getDate()} ${
                                months[
                                  new Date(
                                    surveyDetails.dateOfCutting,
                                  ).getMonth()
                                ]
                              } ${new Date(
                                surveyDetails.dateOfCutting,
                              ).getFullYear()}` || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Number of Picking
                            <span>
                              {surveyDetails.pickingCount || 'xxxxxxx'}
                            </span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>
                        Harvest Details
                        {' '}
                        <span>Co ordinates: 564543.787645</span>
                      </h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Manure Usage
                            {' '}
                            <strong>
(
                              {surveyDetails.manureUsedUnit}
)
                            </strong>
                            {' '}
                            <span>
                              {surveyDetails.manureUsedPerUnit || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Irrigation Type
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Dried & Harvesting at
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Other Data A
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Fertilizer Usage
                            <strong>
                              (
                              {surveyDetails.chemicalFertilizerUsedUnit}
)
                            </strong>
                            <span>
                              {surveyDetails.chemicalFertilizerUsedPerUnit
                                || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Irrigation Source
                            <span>
                              {surveyDetails.sourceOfIrrigation || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Weighing Date
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Other Data B
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Sub Section C</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__img">
                      {stage2Media.map((item, index) => {
                        if (index < 5) {
                          return (
                            <figure key={item.stage2ID}>
                              <img
                                src={`${mediaURL}${item.mediaRelativePath}`}
                                alt={`0${index + 1}`}
                              />
                              <p>
                                {item.mediaType
                                  ? item.mediaType.split('_').join(' ')
                                  : `Media ${index + 1}`}
                              </p>
                            </figure>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  </div>
                  <Grid container className="survey-tab__footer">
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Delete</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Download</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">CTA</button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
          {
            tabName: 'Part-3 yield-overview',
            component: (
              <div className="survey-tab">
                <div className="survey-tab__content">
                  <div className="survey-tab__body">
                    <Grid container className="survey-tab__body__palette">
                      <h1>Weighing Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Crop Variety
                            <span>
                              {surveyDetails.cropVariety || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Variety Source
                            <span>
                              {surveyDetails.seedVarietySource || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Dry/wet weight
                            <strong>(Unit)</strong>
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Moisture %
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Variety Name
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Trees/Fruits Count
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Production Status
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Driage Ratio
                            <span>
                              {surveyDetails.driageRatio || 'xxxxxxx'}
                            </span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Yield Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Avg Yield
                            <strong>
                              (
                              {surveyDetails.averageYieldUnit}
)
                            </strong>
                            {' '}
                            <span>
                              {surveyDetails.averageYield || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Damage in (%)
                            <span>{surveyDetails.pestDamage || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Stress Type
                            <span>{surveyDetails.stressType || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Data Point C
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Produce Type
                            <span>
                              {surveyDetails.cceProduceType || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Remarks
                            <span>{surveyDetails.remarks || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Weather Status
                            <span>
                              {surveyDetails.weatherCondition || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Data Point D
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Sub Section C</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__img">
                      {stage2Media.map((item, index) => {
                        if (index < 5) {
                          return (
                            <figure key={item.stage2ID}>
                              <img
                                src={`${mediaURL}${item.mediaRelativePath}`}
                                alt={`0${index + 1}`}
                              />
                              <p>
                                {item.mediaType
                                  ? item.mediaType.split('_').join(' ')
                                  : `Media ${index + 1}`}
                              </p>
                            </figure>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  </div>
                  <Grid container className="survey-tab__footer">
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Delete</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Download</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">CTA</button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
          {
            tabName: 'Supervision',
            component: (
              <div className="survey-tab">
                <div className="survey-tab__content">
                  <div className="survey-tab__body">
                    <Grid container className="survey-tab__body__palette">
                      <h1>Supervisor Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Supervisor Designation
                            <span>
                              {surveyDetails.supervisorDesignation || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Supervisor Mobile No.
                            <span>
                              {surveyDetails.supervisorMobile || 'xxxxxxx'}
                            </span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Supervisor Name
                            <span>
                              {surveyDetails.supervisorName || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Remarks
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Submission Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Agent Name
                            {' '}
                            <span>{surveyDetails.agentName || 'xxxxxxx'}</span>
                          </li>
                          <li>
                            Part 1 Date
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Date of Allocation
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Agent Mobile No.
                            <span>
                              {surveyDetails.agentMobile || 'xxxxxxx'}
                            </span>
                          </li>
                          <li>
                            Final Submission Date
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Smart Sampling
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Sub Section C</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__img">
                      {stage2Media.map((item, index) => {
                        if (index < 5) {
                          return (
                            <figure key={item.stage2ID}>
                              <img
                                src={`${mediaURL}${item.mediaRelativePath}`}
                                alt={`0${index + 1}`}
                              />
                              <p>
                                {item.mediaType
                                  ? item.mediaType.split('_').join(' ')
                                  : `Media ${index + 1}`}
                              </p>
                            </figure>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  </div>
                  <Grid container className="survey-tab__footer">
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Delete</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Download</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">CTA</button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
          {
            tabName: 'Satellite-verification',
            disabled: true,
            component: (
              <div className="survey-tab">
                <div className="survey-tab__content">
                  <div className="survey-tab__body">
                    <Grid container className="survey-tab__body__palette">
                      <h1>Land Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Land Shape File
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Identified Crop
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Harvesting Week
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Max NDVI
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Shape File Area
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Sowing Week
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Irrigation Status
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Avg NDVI
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Yield Details</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__details">
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul>
                          <li>
                            Health Status
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Field Relative Index
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Estimated Yield
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <ul className="survey-tab__body__details--right">
                          <li>
                            Loss Percentage
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            Avg Yield
                            <span>xxxxxxx</span>
                          </li>
                          <li>
                            DB Value
                            <span>xxxxxxx</span>
                          </li>
                        </ul>
                      </Grid>
                    </Grid>
                    <Grid container className="survey-tab__body__palette">
                      <h1>Sub Section C</h1>
                    </Grid>
                    <Grid container className="survey-tab__body__img">
                      {stage2Media.map((item, index) => {
                        if (index < 5) {
                          return (
                            <figure key={item.stage2ID}>
                              <img
                                src={`${mediaURL}${item.mediaRelativePath}`}
                                alt={`0${index + 1}`}
                              />
                              <p>
                                {item.mediaType
                                  ? item.mediaType.split('_').join(' ')
                                  : `Media ${index + 1}`}
                              </p>
                            </figure>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  </div>
                  <Grid container className="survey-tab__footer">
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Delete</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">Download</button>
                    </Grid>
                    <Grid
                      item
                      className="survey-tab__footer--btn"
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                    >
                      <button type="button">CTA</button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
          {
            tabName: 'Summary',
            component: <div />,
          },
        ];
      }
    }
    return (
      <div className="survey-modal">
        {/* Condition for Loader.
            Used the same Popup Layout for Loader
         */}
        {experimentDetailLoading ? (
          <div>
            <div>
              <div className="survey-modal__content">
                <div className="survey-modal__header">
                  <h1>
                    CCE INSPECTION REPORT
                    {' '}
                    <i
                      role="button"
                      tabIndex="0"
                      onKeyDown={closePopupFunc}
                      className="material-icons"
                      onClick={closePopupFunc}
                    >
                      close
                    </i>
                  </h1>
                </div>
              </div>
              <div className="survey-modal__body">
                <Grid container className="survey-modal__body__head">
                  <Grid
                    item
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    className="survey-modal__body__head--left"
                  >
                    ID:
                    {previewExperimentNumber}
                    {/*   <div class="survey-modal__body__head--left">
                          ID:677667
                      </div>
                      <div class="survey-modal__body__head--right">
                          Date
                      </div> */}
                  </Grid>
                  <Grid
                    item
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    className="survey-modal__body__head--right"
                  >
                    Date
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <ScrollableTabPanel
                      tabsData={[
                        {
                          tabName: 'Part 1 Field Overview',
                          component: (
                            <div className="survey-tab">
                              <div className="survey-tab__content">
                                <div className="survey-tab__body">
                                  {/*                                  <Grid
                                    container
                                    className="survey-tab__body__palette"
                                  >
                                    <h1>Loader</h1>
                                  </Grid> */}
                                  <Grid
                                    container
                                    className="survey-tab__body__details"
                                  >
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Loader />
                                    </Grid>
                                  </Grid>
                                </div>
                                <Grid container className="survey-tab__footer">
                                  <Grid
                                    item
                                    className="survey-tab__footer--btn"
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={12}
                                  >
                                    <button type="button">Delete</button>
                                  </Grid>
                                  <Grid
                                    item
                                    className="survey-tab__footer--btn"
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={12}
                                  >
                                    <button type="button">Download</button>
                                  </Grid>
                                  <Grid
                                    item
                                    className="survey-tab__footer--btn"
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={12}
                                  >
                                    <button type="button">CTA</button>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          ),
                        },
                      ]}
                      customStyle="surveyTabPanel"
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {/* Condition For Empty Data or Error
              Used the same Popup Layout for Loader
             */}
            {_.isEmpty(experimentDetail) && experimentDetailError !== '' && (
              <div>
                <div className="survey-modal__content">
                  <div className="survey-modal__header">
                    <h1>
                      CCE INSPECTION REPORT
                      {' '}
                      <i
                        role="button"
                        tabIndex="0"
                        onKeyDown={closePopupFunc}
                        className="material-icons"
                        onClick={closePopupFunc}
                      >
                        close
                      </i>
                    </h1>
                  </div>
                </div>
                <div className="survey-modal__body">
                  <Grid container className="survey-modal__body__head">
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="survey-modal__body__head--left"
                    >
                      ID:
                      {previewExperimentNumber}
                      {/*   <div class="survey-modal__body__head--left">
                          ID:677667
                      </div>
                      <div class="survey-modal__body__head--right">
                          Date
                      </div> */}
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="survey-modal__body__head--right"
                    >
                      Date
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <ScrollableTabPanel
                        tabsData={[
                          {
                            tabName: 'Part 1 Field Overview',
                            component: (
                              <div className="survey-tab">
                                <div className="survey-tab__content">
                                  <div className="survey-tab__body">
                                    <Grid
                                      container
                                      className="survey-tab__body__palette"
                                    >
                                      <h1>Error</h1>
                                    </Grid>
                                    <Grid
                                      container
                                      className="survey-tab__body__details"
                                    >
                                      <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <h2>{experimentDetailError}</h2>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <Grid
                                    container
                                    className="survey-tab__footer"
                                  >
                                    <Grid
                                      item
                                      className="survey-tab__footer--btn"
                                      lg={4}
                                      md={4}
                                      sm={4}
                                      xs={12}
                                    >
                                      <button type="button">Delete</button>
                                    </Grid>
                                    <Grid
                                      item
                                      className="survey-tab__footer--btn"
                                      lg={4}
                                      md={4}
                                      sm={4}
                                      xs={12}
                                    >
                                      <button type="button">Download</button>
                                    </Grid>
                                    <Grid
                                      item
                                      className="survey-tab__footer--btn"
                                      lg={4}
                                      md={4}
                                      sm={4}
                                      xs={12}
                                    >
                                      <button type="button">CTA</button>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                            ),
                          },
                        ]}
                        customStyle="surveyTabPanel"
                      />
                    </Grid>
                  </Grid>
                </div>
                {/*        <h2>{description}</h2>
              <Button
                variant="contained"
                className="button btn-success startBtn"
                onClick={() => closePopupFunc()}
              >
                Close
              </Button> */}
                {/*        <Grid container className="root gis-main1" justify="center">
                <ScrollableTabPanel
                  tabsData={tabsData}
                  customStyle="surveyTabPanel"
                />
              </Grid> */}
              </div>
            )}
            {/* Condition of Data Success */}
            {!_.isEmpty(experimentDetail) && surveyDetails && (
              <div>
                <div className="survey-modal__content">
                  <div className="survey-modal__header">
                    <h1>
                      CCE INSPECTION REPORT
                      {' '}
                      <i
                        role="button"
                        tabIndex="0"
                        onKeyDown={closePopupFunc}
                        className="material-icons"
                        onClick={closePopupFunc}
                      >
                        close
                      </i>
                    </h1>
                  </div>
                </div>
                <div className="survey-modal__body">
                  <Grid container className="survey-modal__body__head">
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="survey-modal__body__head--left"
                    >
                      ID:
                      {surveyDetails.experimentNumber}
                      {/*   <div class="survey-modal__body__head--left">
                            ID:677667
                        </div>
                        <div class="survey-modal__body__head--right">
                            Date
                        </div> */}
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="survey-modal__body__head--right"
                    >
                      Date:
                      {`${new Date(surveyDetails.inspectionDate).getDate()} ${
                        months[
                          new Date(surveyDetails.inspectionDate).getMonth()
                        ]
                      } ${new Date(
                        surveyDetails.inspectionDate,
                      ).getFullYear()}`}
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <ScrollableTabPanel
                        tabsData={tabsData}
                        customStyle="surveyTabPanel"
                      />
                    </Grid>
                  </Grid>
                </div>
                {/*        <h2>{description}</h2>
                <Button
                  variant="contained"
                  className="button btn-success startBtn"
                  onClick={() => closePopupFunc()}
                >
                  Close
                </Button> */}
                {/*        <Grid container className="root gis-main1" justify="center">
                  <ScrollableTabPanel
                    tabsData={tabsData}
                    customStyle="surveyTabPanel"
                  />
                </Grid> */}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    ({ survey }) => ({
      showPopup: survey.showPopup,
      markerIndex: survey.markerIndex,
      surveyData: survey.surveyData,
      experimentDetailLoading: survey.experimentDetailLoading,
      experimentDetail: survey.experimentDetail,
      experimentDetailError: survey.experimentDetailError,
      previewExperimentNumber: survey.previewExperimentNumber,
    }),
    dispatch => ({
      closePopupFunc: () => dispatch(closePopupAction()),
    }),
  )(withCookies(CCEPopup)),
);
